import requestAction from '../../utils/requestAction'

export const fetchBouncedReceipts = (params: string) => 
  requestAction('BOUNCED_RECEIPT_LIST', params)(`bouncedReceipts`, 'GET')
